import { cloneDeep } from "lodash-es";
import { universalTemplate } from "../templates/Universal";
/**
 * 更加 api 名字获取DB参数schema
 * @param api
 * @returns
 */
export function getDBParamsSchema(api, entity) {
  var _entity$fields;
  const apiTemplate = universalTemplate.apiTemplates.find(item => item.name === api);
  if (!apiTemplate) return {
    fields: []
  };
  const {
    request
  } = apiTemplate;
  const paramsSchema = {
    fields: []
  };
  const hasEntity = entity === null || entity === void 0 || (_entity$fields = entity.fields) === null || _entity$fields === void 0 ? void 0 : _entity$fields.length;
  ['query', 'body'].forEach(name => {
    var _request$name, _paramsSchema$fields;
    if (!((_request$name = request[name]) !== null && _request$name !== void 0 && _request$name.useInDB)) return;
    const schema = cloneDeep(request[name]);
    if (hasEntity && name === 'query' && ['list', 'count'].includes(api)) {
      var _schema$fields, _filterSchema$items;
      const filterSchema = (_schema$fields = schema.fields) === null || _schema$fields === void 0 || (_schema$fields = _schema$fields.find(item => item.id === 'filter')) === null || _schema$fields === void 0 ? void 0 : _schema$fields.jsonStringType;
      const keyField = filterSchema === null || filterSchema === void 0 || (_filterSchema$items = filterSchema.items) === null || _filterSchema$items === void 0 || (_filterSchema$items = _filterSchema$items.fields) === null || _filterSchema$items === void 0 ? void 0 : _filterSchema$items.find(item => item.id === 'k');
      if (keyField) {
        // 写个enum，让他们支持下拉选择
        const enumArray = entity.fields.map(item => {
          const id = String(item.id);
          return {
            value: id,
            label: [id, item.title ? `(${item.title})` : ''].join('')
          };
        });
        keyField.enum = enumArray;
      }
    }
    (_paramsSchema$fields = paramsSchema.fields) === null || _paramsSchema$fields === void 0 || _paramsSchema$fields.push({
      id: name,
      ...schema
    });
  });
  return paramsSchema;
}
//# sourceMappingURL=getDBParamsSchema.js.map
